"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancel = exports.select = exports.setSelection = exports.moveSelection = exports.drawAll = exports.close = exports.open = exports.isOpen = exports.get = void 0;
var mathUtils_sidecar_1 = require("../../../lib/mathUtils-sidecar");
var rogueInput_sidecar_1 = require("../input/rogueInput-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueCursor_1 = require("./rogueCursor");
var rogueCursor_sidecar_1 = require("./rogueCursor-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            items: [],
            isOpen: false,
            highlighted: 0,
        };
        _obj.items.push({
            name: "Fireball",
            letter: 'f',
            action: function () {
                rogueCursor_sidecar_1.rogueCursor.setTargetMode(rogueCursor_1.ERogueTargetMode.fireball);
            },
        });
        _obj.items.push({
            name: "Teleport",
            letter: 't',
            action: function () {
                rogueCursor_sidecar_1.rogueCursor.setTargetMode(rogueCursor_1.ERogueTargetMode.teleport);
            },
        });
        _obj.items.push({
            name: "Look",
            letter: 'l',
            action: function () {
                rogueCursor_sidecar_1.rogueCursor.setTargetMode(rogueCursor_1.ERogueTargetMode.look);
            },
        });
    }
    return _obj;
};
exports.get = get;
var isOpen = function () {
    return (0, exports.get)().isOpen;
};
exports.isOpen = isOpen;
var open = function () {
    var obj = (0, exports.get)();
    obj.isOpen = true;
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
};
exports.close = close;
var drawAll = function () {
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    var x = 1;
    var y = 1;
    (0, exports.moveSelection)(0, 0); // Reset wrap
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Cast');
    y++;
    var _loop_1 = function (i) {
        var item = obj.items[i];
        y++;
        var isHighlighted = i === obj.highlighted;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (isHighlighted ? '>' : ' ') + item.letter + ':' + item.name, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
            (0, exports.setSelection)(i);
            (0, exports.select)();
        }, function () {
            (0, exports.setSelection)(i);
        }, item.letter);
    };
    for (var i = 0; i < obj.items.length; i++) {
        _loop_1(i);
    }
};
exports.drawAll = drawAll;
var moveSelection = function (oy, ox) {
    var obj = (0, exports.get)();
    (0, exports.setSelection)(obj.highlighted + oy);
};
exports.moveSelection = moveSelection;
var setSelection = function (selIdx) {
    var obj = (0, exports.get)();
    obj.highlighted = selIdx;
    // Wrap
    obj.highlighted = mathUtils_sidecar_1.mathUtils.betterMod(obj.highlighted, obj.items.length);
};
exports.setSelection = setSelection;
var select = function () {
    var obj = (0, exports.get)();
    var item = obj.items[obj.highlighted];
    if (item.action) {
        item.action();
    }
    if (item.command) {
        rogueInput_sidecar_1.rogueInput.setNextInputCommand(item.command);
    }
    (0, exports.close)();
};
exports.select = select;
var cancel = function () {
    (0, exports.close)();
};
exports.cancel = cancel;
